// extracted by mini-css-extract-plugin
module.exports = {"width":"contact_width___OMUu","hero-text":"contact_hero-text__EuGPo","wrapper":"contact_wrapper__VsK_d","split":"contact_split__Snv7_"};